import React from 'react'
import { Link } from 'react-router-dom'
import ReadMore from '../Common/ReadMore'
import Slider from "react-slick";
import { getImages } from '../Common/const';

const SrpMdBox = ({ item, index, numberFormatter, priceFormatter }) => {

    const optionssl = {
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        dots: true
    };
    return (
        <>
            <div className='col-lg-8 col-md-12 col-12' key={index}>
                <Link to={"/vdp?vin=" + item.vin}>
                    <div className='pro-box pro-full-width'>
                        <div className='before-hover d-flex align-items-center p-0'>
                            <div className='pro-bottom p-md-4 p-4'>
                                {/* <div className='pb-logo mb-md-4 mb-2'>
                                <img src={getImages('mclaren-logo.svg')} />
                            </div> */}
                                <div className='lg-title text-uppercase mb-lg-4 mb-3 text-theme font-3em'>Latest Drop</div>
                                <div className="xs-title font-2em mb-md-3 mb-2 fw-500">{item.make} {item.model} {item.trim}</div>
                                <div className="xs-title font-1em opacity-0-5 fw-300">{item.mileage.toLocaleString()}mi</div>
                                <div className="sm-title font-2-5em">{priceFormatter(item.price, true)}</div>
                                <div className='financing-abl-btn mt-5 text-uppercase'>Financing Available</div>
                            </div>
                            <div className='pro-top position-relative'>
                                {item.images.length > 0 ?
                                    <img src={item.images[0]} alt='srp' />
                                :
                                            <img src={getImages('vdp_top_coming_soon.webp')} alt='' />
                                }
                            </div>
                        </div>
                    </div>
                </Link>
            </div>
        </>
    )
}

export default SrpMdBox